import {decorate, observable} from 'mobx';
import {faHistory} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel} from './base';

export const MAX_LOGS = 1000;

export class EventLog extends BaseModel {
  static faIcon = faHistory;

  searchableProperties = ['user.fullName', 'order.no', 'hierarchy', 'message'];

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.user = rootStore.userStore.getById(this.userId);
    this.order = rootStore.orderStore.getById(this.orderId);
    this.hierarchy = rootStore.hierarchyStore.getById(this.hierarchyId);
    this.inspectionLot = rootStore.inspectionLotStore.getById(this.inspectionLotId);
  }
}

decorate(EventLog, {
  id: observable,
  message: observable,
  timestamp: observable,
  logLevel: observable,
  context: observable,
  user: observable,
  userId: observable,
  order: observable,
  orderId: observable,
  hierarchy: observable,
  hierarchyId: observable,
  inspectionLot: observable,
  inspectionLotId: observable,
  referenceLabel: observable,
  referenceKey: observable,
  externalResourceId: observable,
});

/**
 * event context translations:
 * t('eventLog.contexts.CUSTOM_ACTION')
 * t('eventLog.contexts.ORDER')
 * t('eventLog.contexts.PERSONNEL')
 * t('eventLog.contexts.SECURITY')
 * t('eventLog.contexts.STATE_CHANGE')
 * t('eventLog.contexts.SYSTEM')
 * t('eventLog.contexts.TASK')
 * t('eventLog.contexts.USER')
 * t('eventLog.contexts.WORKFLOW_CORRECTION')
 * t('eventLog.contexts.INSPECTION_IMPORT')
 * t('eventLog.contexts.EXTERNAL_RESOURCE')
 * t('eventLog.contexts.INTERRUPTION')
 */
export const EventLogContexts = Object.freeze({
  CustomAction: 'CUSTOM_ACTION',
  Order: 'ORDER',
  Personnel: 'PERSONNEL',
  Security: 'SECURITY',
  StateChange: 'STATE_CHANGE',
  SYSTEM: 'SYSTEM',
  Task: 'TASK',
  User: 'USER',
  WorkflowCorrection: 'WORKFLOW_CORRECTION',
  ExternalResource: 'EXTERNAL_RESOURCE',
  Interruption: 'INTERRUPTION',
});

/**
 * event log-level translations:
 * t('eventLog.logLevels.1')
 * t('eventLog.logLevels.2')
 * t('eventLog.logLevels.3')
 * t('eventLog.logLevels.4')
 */
export const EventLogLevels = Object.freeze({Info: 1, Warning: 2, Error: 3, Fatal: 4});
